import { CalculatedFieldProps } from "../../types";
import * as Classes from "./classes";
import { defineBaseFieldComponent } from "./baseField";

export const CalculatedField = defineBaseFieldComponent<CalculatedFieldProps, ReturnType<typeof formatField>>(
    {
        name: "calculatedField",
        additionalRowAttributes: (field) => (
            {
                class: [Classes.treebrowserow, Classes.jsDraggable, Classes.calculatedField],
                        "data-fieldid": field.id,
                        "data-field-type": field.dataType,
                        "data-display-path-text": field.fieldName,
                        "data-svg-class": getSvgIconForType(field.dataType),
            }),
        nameCell: (field) => <td><span>{field.fieldName}</span></td>,
        typeIcon: (field) => getSvgIconForType(field.dataType),
        fieldKey: (field) => field.id,
        formatField:formatField,
    }
);

function formatField(field: CalculatedFieldProps)
{
    const result =
    {
        // These correspond to old data- attribute names, used in reporting and elsewhere
        fieldType: field.dataType,

        // Used by filterbuilder.js
        displayPathText: field.fieldName,

        // used by calculatedfieldlist.js
        isCalculatedField: true
    };
    return result;
}

// See GetSvgIconForType() in Svg.cs
function getSvgIconForType(dataType: string)
{
    if (dataType?.indexOf("GroupColumn") != -1)
    {
        return "Columns";
    }

    switch (dataType?.split(' ')[0])
    {
        case "Number":
            return "Number";
        case "String":
            return "TextCharacter";
        case "OneToMany":
            return "OneToMany";
        case "ManyToOne":
            return "ClosedFolderAlt";
        case "Boolean":
            return "CheckBox";
        case "Time":
        case "DateTime":
            return "Date";
        case "TimeSpan":
            return "Timespan";
        case "Image":
            return "InsertImage";
        case "List":
            return "List";
        default:
            return "NoImage";
    }
}
